import * as fuzz from "fuzzball";
import { gjsonprop, gcongoinedrecognitionresult, gconvocollectionconf, grecognitionresult, gqasimplified, gselectedgroup } from "../../interfaces";
import { removeEnclosingQuotes, getAlphaNumeric, getOnlyNumeric, getLettersOnly, newConvoStamp, fuzzMtch, bestWildcardMatch } from "../../util_glob";
import { qTopicChange, qAiMatching } from "./../../api";
import { PrefixSuffixSplitResult, ExractionFieldConfig } from "./../../interfaces";
import { getGroundingDataSet } from "./recog_util";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import { setConvoV2State } from "../../pages/chat/ChatUtil";

type AddRecogPhrasesResult = [success: boolean, maxLength: number, phrases: string[]];

let PHONE_NUMBER_UI_CONFIG_NAME = "User_Id";

// NEW REWRITE
export const resetConjoinedConditionalOG = (mainState: any, streamSid: string) => {
    if ("conversation_state" in mainState[streamSid]) {
        const convoState = mainState[streamSid]["conversation_state"];
        const runOn = convoState["global_run_on_sentence"] || { segments: [], recognized: [] };
        const cadenceStamp = parseInt(mainState[streamSid]["global_convo_cadance_stamp"] || 0, 10);

        const cadenceDate = parseConvoTimestampHires(cadenceStamp);

        const segmentsKept = (runOn.segments || []).filter((item: any) => parseConvoTimestampHires(item?.cadancestamp || 0) > cadenceDate);

        const recognizedKept = (runOn.recognized || []).filter((item: any) => parseConvoTimestampHires(item?.cadancestamp || 0) > cadenceDate);

        mainState[streamSid]["conversation_state"]["global_run_on_sentence"] = {
            segments: segmentsKept,
            recognized: recognizedKept
        };
    }
};

// NEW REWRITE

// NEW REWRITE
export const conv_collect_replacements = [
    { text: "€", replacement: "e" },
    { text: "сaвa ", replacement: "св " },
    { text: "сава ", replacement: "св " },
    { text: "силва ", replacement: "св " },
    { text: "силва ", replacement: "св " },
    { text: "сaв ", replacement: "св " },
    { text: "съвъ ", replacement: "св " },
    { text: "съв ", replacement: "св " },
    { text: "шейсе", replacement: "60" },
    { text: "буква по буква", replacement: "буквa по буквa." },
    { text: "буквa по буквa", replacement: "буквa по буквa." },
    { text: "цифрa по цифрa", replacement: "цифрa по цифрa." },
    { text: "цифра по цифра", replacement: "цифрa по цифрa." }
];

// NEW REWRITE
export const valueSpecificRules = (expRespType: string, conjoinedObj: gcongoinedrecognitionresult) => {
    if (!expRespType) return true;

    const uiNumberConfigName = PHONE_NUMBER_UI_CONFIG_NAME.toLowerCase()
        .trim()
        .replace(/[^A-Za-zА-Яа-я]/g, "");
    const keylet = expRespType
        .toLowerCase()
        .trim()
        .replace(/[^A-Za-zА-Яа-я]/g, "");

    const conjoinedSegments = (conjoinedObj["conjoined_segments"] || "").toLowerCase().trim();
    const msgNumeric = getOnlyNumeric(conjoinedSegments);
    const lastCharMatch = conjoinedSegments.match(/[A-Za-zА-Яа-я0-9]/g);
    const lastChar = lastCharMatch ? lastCharMatch[lastCharMatch.length - 1] : "";

    if (keylet.includes("carregistration")) {
        if (msgNumeric.length > 3) {
            return true;
        }
    } else if (keylet.includes(uiNumberConfigName)) {
        if (msgNumeric.length > 4) {
            return true;
        }
    } else {
        return true;
    }

    return false;
};

// NEW REWRITE
export const applyReplacements = (inputStr: string, replacements: { text: string; replacement: string }[]) => {
    let result = inputStr;
    for (const item of replacements) {
        const regex = new RegExp(item.text, "g");
        result = result.replace(regex, item.replacement);
    }
    return result;
};

// NEW REWRITE
export const msgObjectReplacements = (fin: any, replacements: { text: string; replacement: string }[]) => {
    fin.conjoined_obj.conjoined_segments = applyReplacements(fin.conjoined_obj.conjoined_segments, replacements);
    fin.conjoined_obj.conjoined_msg = applyReplacements(fin.conjoined_obj.conjoined_msg, replacements);
    return fin;
};

// NEW REWRITE
export const getFieldConfigForExpectedResponseType = (expRespType: string, docX: gjsonprop[]) => {
    const typeAlphanum = getAlphaNumeric(expRespType.toLowerCase());
    // Find the first field config whose name matches part of the alphanumeric response type
    const typeConfList = docX.filter(item => typeAlphanum.includes(getAlphaNumeric(item.name.toLowerCase())));
    return typeConfList.length > 0 ? typeConfList[0] : null;
};

// NEW REWRITE
export const getSameSourceConf = (mainConfFid: string, docX: gjsonprop[]): gjsonprop[] => {
    return docX.filter(item => item.hasOwnProperty("validation_source") && item["validation_source"] == mainConfFid);
};

// NEW REWRITE
export const getMainAndRelatedFieldConfigsForExpectedIntend = (expRespType: string, docX: gjsonprop[]) => {
    // Get field config for expected response type
    const expRespTypeConf = getFieldConfigForExpectedResponseType(expRespType, docX);
    // Get validation source ID from field config (default to "0")
    const typeSourceFid = expRespTypeConf ? expRespTypeConf["validation_source"] || "0" : "0";
    // Get related field configs with the same validation source
    const allRelatedConfigs = getSameSourceConf(typeSourceFid, docX);
    // Return [main field config, all related field configs]
    return {
        mainConf: expRespTypeConf,
        allRelatedConfigs: allRelatedConfigs
    };
};

// NEW REWRITE
export const getGroundingDataSetV2 = (expRespType: string, docX: gjsonprop[], fileListCache: any[]) => {
    if (!expRespType) {
        return {
            values: [],
            keyname: expRespType,
            shouldGo: false,
            joinkeys: [],
            all_related_configs: [],
            conf: null
        };
    }
    if (!docX) {
        return {
            values: [],
            keyname: expRespType,
            shouldGo: true,
            joinkeys: [],
            all_related_configs: [],
            conf: null
        };
    }

    const { mainConf, allRelatedConfigs } = getMainAndRelatedFieldConfigsForExpectedIntend(getAlphaNumeric(expRespType.toLowerCase()), docX);

    if (allRelatedConfigs?.length > 0 && mainConf) {
        const mainConfFid = mainConf["validation_source"] || "0";
        const additionalSrcNames = [...new Set(allRelatedConfigs.map((c: any) => c["name"]))];
        const sourceData = fileListCache.find(item => parseInt(item["fileid"] || 0) === parseInt(mainConfFid));

        if (sourceData) {
            try {
                let rawData = sourceData["invoicedata"] || "[]";
                let jsonParsed;

                if (typeof rawData === "string") {
                    jsonParsed = JSON.parse(removeEnclosingQuotes(rawData || "[]"));
                } else {
                    jsonParsed = rawData || [];
                }

                return {
                    values: jsonParsed,
                    keyname: expRespType,
                    shouldGo: true,
                    joinkeys: additionalSrcNames,
                    all_related_configs: allRelatedConfigs,
                    conf: mainConf
                };
            } catch (e) {
                return {
                    values: [],
                    keyname: expRespType,
                    shouldGo: true,
                    joinkeys: additionalSrcNames,
                    all_related_configs: allRelatedConfigs,
                    conf: mainConf
                };
            }
        } else {
            console.log("NO_SOURCE_DATA");
            return {
                values: [],
                keyname: expRespType,
                shouldGo: true,
                joinkeys: additionalSrcNames,
                all_related_configs: allRelatedConfigs,
                conf: mainConf
            };
        }
    } else {
        return {
            values: [],
            keyname: expRespType,
            shouldGo: true,
            joinkeys: [],
            all_related_configs: [],
            conf: null
        };
    }
};

export const getRandomSymbols = (length = 4) => {
    const symbols = "!@#$%^&*()_+-=[]{}|;:',.<>?/`~";
    let result = "";
    for (let i = 0; i < length; i++) {
        result += symbols[Math.floor(Math.random() * symbols.length)];
    }
    return result;
};

export const parseConvoTimestampHires = (ts: number): Date => {
    if (ts === 0) return new Date();

    const tsStr = ts.toString();
    const mainPart = tsStr.slice(0, -2); // All except last 2 digits
    const fracPart = tsStr.slice(-2); // Last 2 digits

    // Parse main part: yyMMddHHmmss
    const yy = parseInt(mainPart.slice(0, 2), 10);
    const year = 2000 + yy; // Assumes 2000–2099
    const month = parseInt(mainPart.slice(2, 4), 10) - 1; // JS months 0-based
    const day = parseInt(mainPart.slice(4, 6), 10);
    const hour = parseInt(mainPart.slice(6, 8), 10);
    const minute = parseInt(mainPart.slice(8, 10), 10);
    const second = parseInt(mainPart.slice(10, 12), 10);
    const millisecond = parseInt(fracPart, 10) * 10; // Convert hundredths to ms

    return new Date(year, month, day, hour, minute, second, millisecond);
};
export const getConvoKeyTimestampHires = (subMinutes: number = 0) => {
    let now = new Date();
    if (subMinutes !== 0) {
        now = new Date(now.getTime() - subMinutes * 60000);
    }

    const pad = (n: any, width = 2) => n.toString().padStart(width, "0");

    const year = pad(now.getFullYear() % 100);
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hour = pad(now.getHours());
    const minute = pad(now.getMinutes());
    const second = pad(now.getSeconds());
    const hundredths = pad(Math.floor(now.getMilliseconds() / 10));

    const timestamp = `${year}${month}${day}${hour}${minute}${second}${hundredths}`;
    return parseInt(timestamp, 10);
};

export const getNowStampAndTime = () => {
    const nowPre = getConvoKeyTimestampHires();
    const now = parseConvoTimestampHires(nowPre);
    return {
        nowPre: nowPre,
        now: now
    };
};

export const getPendingMsgDiff = (mainState: any, streamSid: string) => {
    const streamState = mainState[streamSid] || {};
    const pendingSentence = streamState.pending_sentence || "";
    const pendingLength = pendingSentence.length;

    const segments = streamState.conversation_state?.global_run_on_sentence?.segments || [];
    const currentSentence = streamState.current_sentence;
    const currentLength = currentSentence ? segments.join(" ").length : 0;

    const pendingDiff = currentLength - pendingLength;
    return pendingDiff > 0 ? pendingDiff : 0;
};

export const resetConjoinedConditionalV2 = () => {
    console.log("resetConjoinedV2");

    const runOn = window.cca.conversation_state?.global_run_on_sentence || { segments: [], recognized: [] };
    const cadenceStamp = window.cca.conversation_state?.global_convo_cadance_stamp || 0;
    const cadenceStampTime = parseConvoTimestampHires(cadenceStamp);

    const segmentsKept = (runOn.segments || []).filter((item: any) => parseConvoTimestampHires(item.cadancestamp ?? 0) > cadenceStampTime);
    setConvoV2State("global_run_on_sentence", segmentsKept, "set_segments");
    console.log("segmentsKept", window.cca);
    const recognizedKept = (runOn.recognized || []).filter((item: any) => parseConvoTimestampHires(item.cadancestamp ?? 0) > cadenceStampTime);
    setConvoV2State("global_run_on_sentence", recognizedKept, "set_recognized");
    console.log("recognizedKept", window.cca);
};

export const fillFinalMsgIfEmpty = (finalUpstreamMsg: string, conjoinedObj: any) => {
    if (finalUpstreamMsg === "") {
        if ((conjoinedObj.conjoined_msg ?? "") !== "") {
            console.log("▩ 33.1");
            finalUpstreamMsg = conjoinedObj.conjoined_msg;
        } else {
            console.log("▩ 33.2");
            finalUpstreamMsg = conjoinedObj.conjoined_segments ?? "";
        }
    }
    return finalUpstreamMsg;
};

export const checkCallerDataHasExpectedResponseType = (data: any, expRespType: string) => {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    const expRespTypeAlphanum = getAlphaNumeric(expRespType.toLowerCase());
    for (const item of data) {
        for (const key of Object.keys(item)) {
            if (getAlphaNumeric(key.toLowerCase()).includes(expRespTypeAlphanum)) {
                return [key]; // Return immediately on first match
            }
        }
    }

    return []; // No match found
};

export const getCallerPrefilterInputCtx = (callerPrefilter: any, expRespType: string, xConf: any, allRelatedConfigs: any[], joinKeys: any[]) => {
    return {
        values: callerPrefilter,
        keyname: expRespType,
        shouldGo: true,
        joinkeys: joinKeys,
        all_related_configs: allRelatedConfigs,
        conf: xConf
    };
};

export const fuzzDownBeatDown = (dataOptions: any, expRespType: string, msgNumeric: string, convState: any, contentSwitch = 1) => {
    const matchDown = crossFuzzAccrossRelated(dataOptions, convState, expRespType, msgNumeric, contentSwitch);

    const matchedStrings = matchDown.map((item: any) => item?.[expRespType]);
    const uniqStrings = [...new Set(matchedStrings)];

    return matchDown;
};

export const crossFuzzAccrossRelated = (dataOptions: any, convState: any, expRespType: string, msgNumeric: string, contentSwitch = 1) => {
    let matchDown = dataOptions.values ?? [];

    if (matchDown.length < 20) console.log("match_down", matchDown);

    const joinKeys = dataOptions.joinkeys ?? [];

    for (const joinKey of joinKeys) {
        let joinDef = "";

        // Main field (expRespType) logic
        if (joinKey === expRespType) {
            switch (contentSwitch) {
                case 1:
                    joinDef = msgNumeric.replace(/\s+/g, "");
                    break;
                case 2:
                    joinDef = "";
                    break;
                case 3:
                    joinDef = getCollectedVal(joinKey, convState);
                    break;
                case 4:
                    joinDef = msgNumeric.replace(/\s+/g, "");
                    break;
                default:
                    joinDef = msgNumeric;
                    break;
            }
            // console.log("🛒 join_def_current", joinKey, "⇒", joinDef);
        } else {
            // Joined field logic
            switch (contentSwitch) {
                case 1:
                case 2:
                case 3:
                    joinDef = getCollectedVal(joinKey, convState);
                    break;
                case 4:
                    joinDef = "";
                    break;
                default:
                    joinDef = getCollectedVal(joinKey, convState);
                    break;
            }
            // console.log("🛒 join_def_non‾current", joinKey, "⇒", joinDef);
        }

        if (joinDef && String(joinDef).trim() !== "") {
            const bestValueMatch = fuzzMatchAgainstCollectedValue(joinDef, matchDown, joinKey);

            if (bestValueMatch && bestValueMatch[joinKey] !== "") {
                console.log("🛒 best_value_match,", matchDown.length);
                const joinMatch = matchDown.filter((val: any) => val[joinKey] === bestValueMatch[joinKey]);

                if (joinMatch.length > 0 && joinMatch.length < matchDown.length) {
                    matchDown = joinMatch;
                    // console.log("🛒 match_down,", matchDown.length);
                }
            }
        }
    }

    return matchDown;
};

export const getCollectedVal = (joinKey: string, convState: any) => {
    let joinVal = "";
    let joinOai = "";

    try {
        const collected = convState.global_convo_collected;
        joinVal = collected?.[joinKey] ?? "";
        joinOai = collected?.[`${joinKey}_ai`] ?? "";
    } catch (error) {
        console.error("errr_joinkey", error);
    }

    const joinDef = joinOai !== "" ? String(joinOai).replace(/\s+/g, "") : String(joinVal).replace(/\s+/g, "");
    return joinDef;
};

export const fuzzMatchAgainstCollectedValue = (spoken: string, itemsArray: any[], propertyName: string) => {
    const spokenNorm = normalize(spoken);
    const spokenDigi = getOnlyNumeric(spokenNorm);

    let bestMatch = null;
    let bestScore = -1;

    const alreadyChecked = new Set();

    for (const item of itemsArray) {
        const valAlphanum = String(item[propertyName] ?? "").toLowerCase();
        if (alreadyChecked.has(valAlphanum)) continue;

        alreadyChecked.add(valAlphanum);

        const textScore = fuzz.partial_ratio(spokenNorm, valAlphanum);
        const digiScore = digitOverlapScore(spokenDigi, getOnlyNumeric(valAlphanum));
        const combinedScore = 0.6 * textScore + 0.4 * digiScore;

        if (combinedScore > bestScore) {
            bestScore = combinedScore;
            bestMatch = item;
        }
    }

    console.log("1best_score", bestScore, "⇒", bestMatch, "itemsArray", itemsArray);

    return bestScore > 0.5 ? bestMatch : null;
};

export const normalize = (text: string) => {
    return text.toLowerCase().replace(/[^A-Za-zА-Яа-я0-9]/g, "");
};

export const digitOverlapScore = (inputDigits: string, targetDigits: string) => {
    let score = 0;
    let i = 0;

    for (const d of targetDigits) {
        while (i < inputDigits.length && inputDigits[i] !== d) {
            i++;
        }
        if (i < inputDigits.length) {
            score++;
            i++;
        }
    }

    return targetDigits.length > 0 ? Math.floor((100 * score) / targetDigits.length) : 0;
};

export const fuzzMatchAgainstStringList = (spoken: string, itemsArray: string[], propertyName: string) => {
    const spokenNorm = normalize(spoken);
    const spokenDigi = getOnlyNumeric(spokenNorm);

    let bestMatch = null;
    let bestScore = -1;

    const alreadyChecked = new Set();

    for (const str of itemsArray) {
        const valAlphanum = String(str).toLowerCase();

        if (alreadyChecked.has(valAlphanum)) continue;
        alreadyChecked.add(valAlphanum);

        const textScore = fuzz.partial_ratio(spokenNorm, valAlphanum);
        const digiScore = digitOverlapScore(spokenDigi, getOnlyNumeric(valAlphanum));
        const combinedScore = 0.6 * textScore + 0.4 * digiScore;

        if (combinedScore > bestScore) {
            bestScore = combinedScore;
            bestMatch = str;
        }
    }

    console.log("2best_score", bestScore, "⇒", bestMatch, "itemsArray", itemsArray);

    return bestScore > 0.5 ? bestMatch : null;
};

export const reinitTrimGlobals = (mainState: any, streamSid: string) => {
    window.cca.is_trimmed_value_collection = false;
    window.cca.max_trimmer_length = 0;
    window.cca.trimmed_phrase_list = [];
    window.cca.trimmed_data_set = [];
    window.cca.trimmed_step_int = 0;
};

export const handleOneFilterMatch = (uniqStrings: any[], fin: any, expRespType: string) => {
    // Use segments instead of final recog due to better preservation
    fin.conj_clean = fin.conjoined_obj.conjoined_segments;

    // Ensure it's a string
    fin.conjoined_obj.conjoined_segments = String(fin.conjoined_obj.conjoined_segments);

    fin.final_upstream_msg = fin.conjoined_obj.conjoined_segments;
    fin.additional_instructions = `1_Correct ${expRespType}: ${uniqStrings[0]}`;

    console.log("handleOnFilMatch", fin.additional_instructions);

    return fin;
};

export const handleMidFilterMatches = (uniqStrings: any[], fin: any, expRespType: string) => {
    fin.conj_clean = fin.conjoined_obj.conjoined_segments;
    fin.conjoined_obj.conjoined_segments = String(fin.conjoined_obj.conjoined_segments);
    fin.final_upstream_msg = fin.conjoined_obj.conjoined_segments;
    fin.additional_instructions = `Correct value options for ${expRespType}: ${uniqStrings.map(String).join(", ")}`;
    return fin;
};

export const filterResultsProcessing = (state: any, uniqStrings: any[], aiValueExtract: any, expectedResponseType: any, finalResultObj: any) => {
    let halt = false;
    const numUnique = uniqStrings.length;
    const convoState = state["conversation_state"] || {};

    const conjoinedSegments = (convoState["global_run_on_sentence"]?.segments || []).map((item: any) => item.msg).join(" ");

    if (numUnique === 1) {
        console.log(`Grounding: Found unique match: ${uniqStrings[0]}`);
        finalResultObj["final_upstream_msg"] = uniqStrings[0];
        finalResultObj["additional_instructions"] = `2_Correct ${expectedResponseType}: ${uniqStrings[0]}`;
        // should_run_oai remains as-is
    } else if (numUnique > 1 && numUnique < 20) {
        finalResultObj["final_upstream_msg"] = finalResultObj["conj_clean"] ?? conjoinedSegments;
        finalResultObj["additional_instructions"] = `Correct value options for ${expectedResponseType}: ${uniqStrings.join(", ")}`;
        // should_run_oai remains as-is
    } else {
        // More than 20 results, try conventional match
        const fallbackInput = aiValueExtract?.requested_value ?? finalResultObj["conj_clean"] ?? conjoinedSegments;

        const conventionalMatch = conventionalFuzzMatch(uniqStrings, fallbackInput);

        if (conventionalMatch) {
            console.log(`Grounding: Found conventional match: ${conventionalMatch}`);
            finalResultObj["final_upstream_msg"] = conventionalMatch;
            finalResultObj["additional_instructions"] = `Possible correct ${expectedResponseType}: ${conventionalMatch}`;
        } else {
            if (aiValueExtract?.user_asks_or_requests) {
                console.log("Grounding: Too many options, no conventional match, user asked question. Passing to AI.");
                finalResultObj["should_run_oai"] = true;
            } else if (!aiValueExtract?.value_ok) {
                console.log("Grounding: Too many options, no conventional match, AI flagged value as not OK. Halting.");
                finalResultObj["should_run_oai"] = false;
                halt = true;
            } else {
                console.log("Grounding: Too many options, no conventional match, AI check passed. Passing original to AI.");
                finalResultObj["should_run_oai"] = true;
            }
        }
    }
    return {
        fin: finalResultObj,
        halt: halt
    };
};

export const conventionalFuzzMatch = (uniqStrings: any[], filterStr: string, thresholdRatio = 70) => {
    if (!uniqStrings || uniqStrings.length === 0 || !filterStr) return "";

    // Option 1: Simple ratio on numeric parts
    const numericFilter = getOnlyNumeric(filterStr.toLowerCase().trim());
    if (!numericFilter) return "";

    let bestMatch = null;
    let highestScore = 0;

    for (const s of uniqStrings) {
        const score = fuzz.ratio(numericFilter, getOnlyNumeric(String(s)));
        if (score > highestScore) {
            highestScore = score;
            bestMatch = s;
        }
    }

    if (highestScore >= thresholdRatio) {
        return bestMatch;
    } else {
        // Option 2: Try extractOne on numeric parts
        const numericUniqStrings = uniqStrings.map((s: any) => getOnlyNumeric(String(s)));

        const result = fuzz.extract(numericFilter, numericUniqStrings, {
            scorer: fuzz.ratio,
            returnObjects: true,
            limit: 1
        })[0];

        if (result && result.score >= thresholdRatio) {
            const originalString = uniqStrings[numericUniqStrings.indexOf(result.choice)];
            return originalString;
        }
    }

    return "";
};

export const emptyPositiveAiResult = () => {
    return {
        has_ai_recognized_value: true,
        requested_value: "",
        value_ok: false,
        user_asks_or_requests: false,
        is_different_direction: false,
        longer_or_eq: false,
        trulyvalidlength: false
    };
};

export async function runAiValCheck(mainState: any, streamSid: string, expRespType: string, msg: string, confDetails: any, selectedGroup: gselectedgroup) {
    const start = performance.now();

    const response = await aiValCheck(
        expRespType,
        msg,
        mainState[streamSid]["last_message"],
        mainState[streamSid]["conversation_state"]["global_expected_next_user_response_type"],
        mainState[streamSid]["conversation_state"]["global_simple_convo_list"],
        confDetails,
        selectedGroup,
        "gpt-4.1-nano"
    );

    console.log("⏱️👾 val_check_perf", ((performance.now() - start) / 1000).toFixed(3));

    return response;
}

export const weAreInSpecificValidation = (expRespType: string) => {
    const keylet = getLettersOnly(expRespType.toLowerCase().trim());
    const uiNumberConfigName = PHONE_NUMBER_UI_CONFIG_NAME.toLowerCase()
        .trim()
        .replace(/[^A-Za-zА-Яа-я]/g, "");

    return keylet.includes("carregistration") || keylet.includes(uiNumberConfigName);
};

async function aiValCheck(
    expRespType: string,
    message: string,
    prev: string,
    prevTopic: string,
    qaList: gqasimplified[],
    confDetails: any,
    selectedGroup: gselectedgroup,
    model = ""
) {
    const topicChange = await qTopicChange(message, prev, prevTopic, qaList, selectedGroup, confDetails);

    const topRes = topicChange?.result || {};
    const inSpecificValidation = weAreInSpecificValidation(expRespType);

    if (inSpecificValidation) {
        const requestedValue = topRes.requested_value || "";

        if (requestedValue !== "") {
            const aiValValid = valueSpecificValidation(expRespType, String(requestedValue));
            return {
                has_ai_recognized_value: true,
                requested_value: requestedValue,
                value_ok: topRes.value_ok || false,
                user_asks_or_requests: topRes.user_asks_or_requests || false,
                is_different_direction: topRes.is_different_direction || false,
                longer_or_eq: aiValValid.longer_or_eq,
                trulyvalidlength: aiValValid.trulyvalidlength
            };
        } else {
            return {
                has_ai_recognized_value: false,
                requested_value: "",
                value_ok: false,
                user_asks_or_requests: topRes.user_asks_or_requests || false,
                is_different_direction: topRes.is_different_direction || false,
                longer_or_eq: false,
                trulyvalidlength: false
            };
        }
    } else {
        const requestedValue = topRes.requested_value || "";
        return {
            has_ai_recognized_value: requestedValue !== "",
            requested_value: requestedValue,
            value_ok: topRes.value_ok || false,
            user_asks_or_requests: topRes.user_asks_or_requests || false,
            is_different_direction: topRes.is_different_direction || false,
            longer_or_eq: false,
            trulyvalidlength: false
        };
    }
}

export const valueSpecificValidation = (expectedResponseType: string, valueExtracted: string) => {
    if (!expectedResponseType || valueExtracted === null || valueExtracted === undefined) {
        return { trulyvalidlength: false, longer_or_eq: false };
    }

    const keylet = getLettersOnly(expectedResponseType.toLowerCase().trim());
    const uiNumberConfigName = PHONE_NUMBER_UI_CONFIG_NAME.toLowerCase()
        .trim()
        .replace(/[^A-Za-zА-Яа-я]/g, "");

    const valueExtractedAlphanum = getAlphaNumeric(String(valueExtracted)).toLowerCase().trim();
    const valLen = valueExtractedAlphanum.length;

    let validPass = false;
    let longerOrEq = false;

    if (keylet.includes("carregistration")) {
        validPass = valLen >= 7 && valLen <= 8;
        longerOrEq = valLen >= 7;
    } else if (keylet.includes(uiNumberConfigName)) {
        validPass = valLen === 8;
        longerOrEq = valLen >= 6;
    } else {
        validPass = true;
        longerOrEq = true;
    }

    return { trulyvalidlength: validPass, longer_or_eq: longerOrEq };
};

export const resetTrimmedCollectionFlags = (mainState: any, streamSid: string) => {
    if (window.cca["is_trimmed_value_collection"] === true) {
        window.cca["trimmed_step_int"] = 0;
        window.cca["trimmed_data_set"] = [];
        window.cca["is_trimmed_value_collection"] = false;
    }
    return mainState;
};

export async function runAiMatching(mainState: any, streamSid: string, fin: any, uniqStrings: any[], confDetails: any) {
    const start = performance.now();

    const response = await qAiMatching(
        fin["conjoined_obj"]["conjoined_segments"],
        (mainState[streamSid]["last_message"] || [""])[0],
        uniqStrings.map(s => String(s)).join(", "),
        mainState[streamSid]["group_id"],
        confDetails["name"],
        confDetails["description"],
        "gpt-4.1-nano"
    );

    console.log("⏱️👾 ai_match_perf", start - performance.now());
    return response;
}

const prefixSuffixUniqueSplit = (strings: string[], tokenCap: number = 500, minLen: number = 3): PrefixSuffixSplitResult => {
    let bestTotal = Infinity;
    let best: PrefixSuffixSplitResult = [null, new Set(), new Set()];

    const maxLen = Math.max(...strings.map(s => s.length));

    for (let n = minLen; n <= maxLen - minLen; n++) {
        const prefixSet = new Set<string>();
        const suffixSet = new Set<string>();

        for (const s of strings) {
            prefixSet.add(s.slice(0, n));
            suffixSet.add(s.slice(n));
        }

        const total = prefixSet.size + suffixSet.size;

        if (total < bestTotal) {
            bestTotal = total;
            best = [n, prefixSet, suffixSet];
        }

        if (total <= tokenCap) {
            return [n, prefixSet, suffixSet];
        }
    }
    return best;
};

export const addRecogPhrasesOneTrim = (newRecognizer: sdk.SpeechRecognizer, phraseList: (string | number)[]): [boolean, number, string[]] => {
    console.log("addRecogPhrasesOneTrim", phraseList);
    try {
        const phraseListGrammar = sdk.PhraseListGrammar.fromRecognizer(newRecognizer);
        phraseListGrammar.clear();

        // Ensure uniqueness like Python set()
        const uniquePhrases = new Set(phraseList.map(p => String(p)));

        if (uniquePhrases.size > 0) {
            const phraseListGrammarDynamic = sdk.PhraseListGrammar.fromRecognizer(newRecognizer);
            const phraseStrings: string[] = [];

            if (uniquePhrases.size < 500) {
                for (const phrase of uniquePhrases) {
                    const formatted = String(phrase).toUpperCase().split("").join(" ");
                    phraseListGrammarDynamic.addPhrase(formatted);
                    phraseStrings.push(formatted);
                }
                console.log(`📦 added ${phraseStrings.length} phrases to recognizer [dynamic]`);
                return [true, 0, phraseStrings];
            } else {
                const [n, prefixes, suffixes] = prefixSuffixUniqueSplit(Array.from(uniquePhrases), 500, 3);

                let trimmedList = Array.from(prefixes).concat(Array.from(suffixes));
                console.log("trimmedListlength", trimmedList.length);
                console.log("trimmedList", trimmedList);
                trimmedList = Array.from(trimmedList).slice(0, 500);

                const maxLength = Math.max(...trimmedList.map(p => String(p).length));

                if (trimmedList.length <= 500) {
                    for (let phrase of trimmedList) {
                        const formatted = String(phrase).toUpperCase().split("").join(" ");
                        phraseListGrammarDynamic.addPhrase(formatted);
                    }
                    console.log(`📦 added ${trimmedList.length} trimmed phrases to recognizer [dynamic2]`, trimmedList);
                    return [false, maxLength, trimmedList];
                } else {
                    console.log("⚠️ Unable to trim phrases to fit under 500.");
                    return [false, -1, trimmedList];
                }
            }
        }
    } catch (err) {
        console.error("errr_phrase_list_addition", err);
        return [false, -1, []];
    }
    return [false, -1, []];
};

const mainCollectedFiltering = () => {
    const xConf: gjsonprop[] = window.cca.docextractionconfig || [];
    const expRespType: string = window.cca.conversation_state?.global_expected_next_user_response_type || "";
    const fileList: any[] = window.cca.file_list_cache || [];

    const dataOptions = getGroundingDataSetV2(expRespType, xConf, fileList);
    console.log("data_options‾joinkeys", dataOptions.joinkeys);

    if (dataOptions.conf) {
        const callerDataOptions = getCallerPrefilterInputCtx(
            dataOptions.values || [],
            expRespType,
            dataOptions.conf,
            dataOptions.all_related_configs,
            dataOptions.joinkeys || []
        );
        const matchDown = fuzzDownBeatDown(callerDataOptions, expRespType, "", window.cca.conversation_state, 2);
        const matchedStrings = matchDown.map((item: any) => item?.[expRespType]);

        const uniqCandidate = Array.from(new Set(matchedStrings));
        return {
            matchDown: matchDown,
            uniqCandidate: uniqCandidate
        };
    } else {
        return {
            matchDown: [],
            uniqCandidate: []
        };
    }
};

export const applyTranscriberPhraseList = (expectedFieldConfig: string): void => {
    const { matchDown, uniqCandidate } = mainCollectedFiltering();
    console.log("uniqCandidate.length", uniqCandidate.length);
    if (uniqCandidate && uniqCandidate.length > 0) {
        const filteredCurrentStrings: string[] = matchDown.map((item: any) => item[expectedFieldConfig]);
        console.log("filteredCurrentStrings01", filteredCurrentStrings);
        if (filteredCurrentStrings && filteredCurrentStrings.length > 0) {
            console.log("filteredCurrentStrings02", filteredCurrentStrings);
            const [isTrimmedValueCollection, maxTrimmerLength, phraseList] = addRecogPhrasesOneTrim(window.cca.transcriber, filteredCurrentStrings);
            window.cca.is_trimmed_value_collection = isTrimmedValueCollection;
            window.cca.max_trimmer_length = maxTrimmerLength;
            window.cca.trimmed_data_set = matchDown;
            window.cca.trimmed_phrase_list = phraseList;
        }
    }
};
